export default {
    sidePill: {
        buy: 'Kupnja',
        sell: 'Prodaja',
    },
}
